export default "__VITE_ASSET__C$VtmB1C__"